module.exports = __webpack_public_path__ + "img/142.faa6fa26.jpg";